import createReactComponent from '../createReactComponent';
var MoveHorizontal = createReactComponent('MoveHorizontal', [['polyline', {
  points: '18 8 22 12 18 16',
  key: '1hqrds'
}], ['polyline', {
  points: '6 8 2 12 6 16',
  key: 'f0ernq'
}], ['line', {
  x1: '2',
  y1: '12',
  x2: '22',
  y2: '12',
  key: 'zvmn4p'
}]]);
export default MoveHorizontal;